import { render, staticRenderFns } from "./disclosure.vue?vue&type=template&id=62ecc04c&"
import script from "./disclosure.vue?vue&type=script&lang=js&"
export * from "./disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports